<template>
  <div class="start">
    <h1>Herzlich Willkommen</h1>
    <p>
      Hier sieht manches noch etwas unfertig aus? Ist es auch! Wir arbeiten gerade am neuen Design – mit einem Neugeborenen im Team kann das allerdings noch etwas dauern.
      Die Inhalte stehen aber schon bereit, also schau dich gerne um!
    </p>

    <h2>Aktuelles / Termine</h2>

    <!-- Tabelle für größere Bildschirme -->
    <table class="termin-table">
    <thead>
        <tr>
        <th>Datum</th>
        <th>Uhrzeit</th>
        <th>Ort</th>
        <th>Veranstaltung</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="event in events" :key="event.id">
            <td>
                <span v-if="event.startDate !== event.endDate">
                    {{ formatDate(event.startDate) }} <br> - {{ formatDate(event.endDate) }}
                </span>
                <span v-else>
                    {{ formatDate(event.startDate) }}
                </span>
            </td>
            <td>{{ event.startTime }} - {{ event.endTime }} Uhr</td>
            <td>{{ event.location }}</td>
            <td>
                <router-link v-if="event.eventUrlRelative" :to="event.eventUrlRelative">{{ event.name }}</router-link>
                <a v-else-if="event.eventUrlExtern" :href="event.eventUrlExtern" target="_blank" rel="noopener noreferrer">
                    {{ event.name }} 🔗
                </a>
                <span v-else>{{ event.name }}</span>
            </td>        
        </tr>
    </tbody>
    </table>

    <!-- Kacheln für mobile Ansicht -->     
    <ul class="termin-liste">
      <li v-for="event in events" :key="event.id" class="termin" @click="handleClick(event)">
        <span class="datum">
            <span v-if="event.startDate !== event.endDate">
            {{ formatDate(event.startDate) }}, {{ event.startTime }} Uhr <br> - {{ formatDate(event.endDate) }}, {{ event.endTime }} Uhr
            </span>
            <span v-else>
            {{ formatDate(event.startDate) }}, {{ event.startTime }} - {{ event.endTime }} Uhr
            </span>
        </span> <br>
        <span class="ort">{{ event.location }}</span> <br>
        <span class="kurs">
            {{ event.name }}
            <span v-if="event.eventUrlExtern" class="extern-symbol">🔗</span>
        </span>
      </li>
    </ul>

    <p>
      Falls du dich zu einem <strong>Kurs anmelden</strong> möchtest oder noch Fragen hast, schreib gerne eine kurze Mail an
      <a href="mailto:info@maikes-familienbegleitung.de">info@maikes-familienbegleitung.de</a>
    </p>
    <p>
      <strong>Ihr seid eine Gruppe</strong> und wünscht euch einen Kurs ganz bequem bei euch im Wohnzimmer? Kein Problem! Meldet euch einfach, wir finden einen Termin!
    </p>
  </div>
</template>

<script>
export default {
  name: "Start",
  data() {
    return {
      defaultOrganizer: {
        type: "Person",
        name: "Maikes Familienbegleitung",
        url: "https://maikes-familienbegleitung.de"
      },
      defaultPerformer: {
        name: "Maike Röhrig"
      },
      defaultDescription: "Ein interaktiver Kurs mit praktischen Tipps und individueller Beratung.",
      defaultImage: "https://maikes-familienbegleitung.de/favicon.svg",
      defaultPrice: "30",
      defaultOfferUrl: "https://maikes-familienbegleitung.de/preise",
      defaultAddress: {
        streetAddress: "Trierer Strasse 250a",
        addressLocality: "Koblenz",
        postalCode: "56072",
        addressCountry: "DE"
      },
      events: [
        { id: 6, name: "Stillvorbereitungskurs", startDate: "2025-05-26", endDate: "2025-05-26", startTime: "19:30", endTime: "21:30", location: "online (Zoom)", isOnline: true, description: "Ein Online-Kurs für werdende Eltern mit Fokus auf Stillvorbereitung.", eventUrlRelative: "/stillvorbereitung" },
        { id: 7, name: "Beikostworkshop", startDate: "2025-05-29", endDate: "2025-05-29", startTime: "10:30", endTime: "12:00", location: "KO-Metternich", isOnline: false, description: "Ein Kurs für Eltern mit Fokus auf den Beikoststart.", eventUrlRelative: "/beikostworkshop" },
        { id: 8, name: "Stillvorbereitungskurs", startDate: "2025-06-04", endDate: "2025-06-04", startTime: "17:00", endTime: "19:00", location: "KO-Metternich", isOnline: false, description: "Ein Kurs für werdende Eltern aus Koblenz und Umgebung mit Fokus auf Stillvorbereitung.", eventUrlRelative: "/stillvorbereitung" },
        { id: 9, name: "Beikostworkshop",        startDate: "2025-06-18", endDate: "2025-06-18", startTime: "15:30", endTime: "17:00", location: "KO-Metternich", isOnline: false, description: "Ein Kurs für junge Eltern mit Fokus auf den Beikoststart.", eventUrlRelative: "/beikostworkshop" }
      ]
    };
  },
  mounted() {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "EventSeries",
      "name": "Kurse und Workshops",
      "event": this.events.map(event => ({
        "@type": "Event",
        "name": event.name,
        "description": event.description || this.defaultDescription,
        "image": event.image || this.defaultImage,
        "startDate": `${event.startDate}T${event.startTime}:00+01:00`,
        "endDate": `${event.endDate}T${event.endTime}:00+01:00`,
        "location": event.isOnline
          ? { "@type": "VirtualLocation", "url": "https://zoom.us" }
          : {
              "@type": "Place",
              "name": event.location,
              "address": event.address || this.defaultAddress
            },
        "eventAttendanceMode": event.isOnline
          ? "https://schema.org/OnlineEventAttendanceMode"
          : "https://schema.org/OfflineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "offers": {
          "@type": "Offer",
          "url": event.eventUrlRelative
            ? "https://maikes-familienbegleitung.de" + event.eventUrlRelative
            : event.eventUrlExtern
                ? event.eventUrlExtern
                : this.defaultOfferUrl,
          "price": event.price || this.defaultPrice,
          "priceCurrency": "EUR",
          "availability": "https://schema.org/InStock",
          "validFrom": "2025-03-01"
        },
        "organizer": event.organizer || this.defaultOrganizer,
        "performer": event.performer
          ? { "@type": "Person", "name": event.performer }
          : { "@type": "Person", "name": this.defaultPerformer }
      }))
    }, null, 2);
    document.head.appendChild(script);
  },
  methods: {
    formatDate(isoDate) {
      const date = new Date(isoDate);
      return date.toLocaleDateString("de-DE", {
        weekday: "short", // Mo, Di, Mi, etc.
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    handleClick(event) {
        if (event.eventUrlExtern) {
            window.open(event.eventUrlExtern, '_blank', 'noopener');
        } else if (event.eventUrlRelative) {
            this.$router.push(event.eventUrlRelative);
        }
    }
  }
};
</script>

<style scoped>
.start {
}

.extern-symbol {
  font-size: 0.8em;
  margin-left: 5px;
}

.termin-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.termin-table th,
.termin-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.termin-liste {
  display: none;
}

@media (max-width: 45rem) {
  .termin-table {
    display: none;
  }
  .termin-liste {
    display: block;
    list-style: none;
    padding: 0;
  }
  .termin {
    background-color: var(--main-color-2);
    margin: 10px 0;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
  .datum {
    font-weight: bold;
  }
  .ort {
    font-style: italic;
  }
}
</style>